import { memo, useEffect, useMemo, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useToggle } from 'react-use';
import { useGetCannyIoBoards, useGetCannyIoToken } from 'shared/data/webApp/v1';

import { useCannySdk } from '../../hooks/useCannySdk';
import { Loading } from './Widget.loading';

export const Widget = memo(() => {
    const { data: cannyIoToken } = useGetCannyIoToken();
    const token = cannyIoToken?.token;

    const { data: cannyIoBoards } = useGetCannyIoBoards();
    const boards = cannyIoBoards?.boards;

    const { boardId } = useParams<{ boardId: string }>();
    const currentBoard = useMemo(() => (boards || []).find(({ id }) => id === boardId), [boards, boardId]);

    const cannyContainerRef = useRef<HTMLDivElement>(null);
    const [isLoading, toggleIsLoading] = useToggle(false);

    useEffect(() => {
        if (!currentBoard || !cannyContainerRef.current || !token) return;

        cannyContainerRef.current.innerHTML = '';
        toggleIsLoading(true);

        window.Canny('render', {
            boardToken: currentBoard.token,
            basePath: null,
            ssoToken: token,
            onLoadCallback: () => toggleIsLoading(false),
        });
    }, [currentBoard, toggleIsLoading, token]);

    useCannySdk();

    return (
        <>
            {isLoading && <Loading />}

            <div data-canny ref={cannyContainerRef} style={isLoading ? { display: 'none' } : undefined} />
        </>
    );
});

Widget.displayName = 'Widget';
